export const trace = import.meta.env.DEV
    ? // biome-ignore lint/suspicious/noExplicitAny: same signature as console.log
      (...args: any) => console.log('[src/index]', ...args)
    : () => {};
